/**
 * @file CommunicationsModal.js
 * @description Modal component for managing communication preferences with radio button selection
 */
import React from 'react';
import style from './modals.module.scss';
import PropTypes from 'prop-types';
import CommunicationPreferences from '../../profile-menu/CommunicationPreferences';
import { getText } from '../../../i18n';

const CommunicationsModal = ({ onYes, onNo, onHide }) => {
    return (
        <div className={`${style.container} modal-backdrop`}>
            <div
                className="modal fade show display-block"
                tabIndex="-1"
                role="dialog"
            >
                <div
                    className={`modal-dialog modal-lg modal-dialog-centered ${style.modalSizing}`}
                >
                    <div className={`modal-content ${style.modalContent}`}>
                        <div>
                            <div className="d-flex align-items-center justify-content-between">
                                <h2
                                    className={`modal-title font-weight-600 ${style.title}`}
                                    style={{ margin: 0, lineHeight: 1 }}
                                >
                                    {getText('msg_690476370b42')}
                                </h2>

                                <button
                                    type="button"
                                    onClick={onHide}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        textDecoration: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                    aria-label={getText('msg_bbfa773e5a63')}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 7 7"
                                        fill="none"
                                        aria-hidden="true"
                                        focusable="false"
                                        style={{
                                            display: 'inline-block',
                                            flexShrink: 0,
                                        }}
                                    >
                                        <path
                                            d="M0.146447 0.146447C0.341709 -0.0488155 0.658291 -0.0488155 0.853553 0.146447L3.5 2.79289L6.14645 0.146447C6.34171 -0.0488155 6.65829 -0.0488155 6.85355 0.146447C7.04882 0.341709 7.04882 0.658291 6.85355 0.853553L4.20711 3.5L6.85355 6.14645C7.04882 6.34171 7.04882 6.65829 6.85355 6.85355C6.65829 7.04882 6.34171 7.04882 6.14645 6.85355L3.5 4.20711L0.853553 6.85355C0.658291 7.04882 0.341709 7.04882 0.146447 6.85355C-0.0488155 6.65829 -0.0488155 6.34171 0.146447 6.14645L2.79289 3.5L0.146447 0.853553C-0.0488155 0.658291 -0.0488155 0.341709 0.146447 0.146447Z"
                                            fill="#667085"
                                        />
                                    </svg>
                                    <span
                                        style={{
                                            marginLeft: 8,
                                            color: '#667085',
                                            lineHeight: 1,
                                        }}
                                    >
                                        {getText('msg_bbfa773e5a63')}
                                    </span>
                                </button>
                            </div>
                        </div>

                        <CommunicationPreferences
                            onYes={onYes}
                            onNo={onNo}
                            onHide={onHide}
                            isModal={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

CommunicationsModal.propTypes = {
    onYes: PropTypes.func.isRequired,
    onNo: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
};

export default CommunicationsModal;
